import { EDataSource } from '@/types';

interface DataSourceDisplay {
	name: string;
	colorClass: string;
}

const DATA_SOURCE_MAP: Record<EDataSource, DataSourceDisplay> = {
	[EDataSource.POLKASSEMBLY]: { name: 'Polkassembly', colorClass: 'bg-pink-500/20 text-pink-600 dark:text-pink-400' },
	[EDataSource.SUBSQUARE]: { name: 'SubSquare', colorClass: 'bg-blue-500/20 text-blue-600 dark:text-blue-400' },
	[EDataSource.SUBSCAN]: { name: 'Subscan', colorClass: 'bg-green-500/20 text-green-600 dark:text-green-400' },
	[EDataSource.INDEXER]: { name: 'Indexer', colorClass: 'bg-purple-500/20 text-purple-600 dark:text-purple-400' },
	[EDataSource.COINGECKO]: { name: 'CoinGecko', colorClass: 'bg-yellow-500/20 text-yellow-600 dark:text-yellow-400' },
	[EDataSource.CRYPTOCOMPARE]: {
		name: 'CryptoCompare',
		colorClass: 'bg-cyan-500/20 text-cyan-600 dark:text-cyan-400'
	},
	[EDataSource.POLKADOT_WIKI]: {
		name: 'Polkadot Wiki',
		colorClass: 'bg-orange-500/20 text-orange-600 dark:text-orange-400'
	},
	[EDataSource.POLKADOT_FORUM]: {
		name: 'Polkadot Forum',
		colorClass: 'bg-violet-500/20 text-violet-600 dark:text-violet-400'
	}
};

const UNKNOWN_SOURCE: DataSourceDisplay = { name: 'Unknown', colorClass: 'bg-muted text-muted-foreground' };

export function getDataSourceDisplay(source: EDataSource): DataSourceDisplay {
	return DATA_SOURCE_MAP[source] ?? UNKNOWN_SOURCE;
}

/** All data sources with display info, ordered for UI listing */
export const ALL_DATA_SOURCES = Object.values(EDataSource).map((source) => ({
	source,
	...DATA_SOURCE_MAP[source]
}));
